import { useEffect, useState } from 'react';
import { EPageType } from '../../types/pages/things-to-do';
import { useAuthContext } from '../../utils/context/authContext';
import Image from 'next/image';
import { useRouter } from 'next/router';
export interface TopTip {
  id: string;
  text: string;
  likes: number;
  dislikes: number;
  liked?: boolean;
  disliked?: boolean;
}

export interface Top {
  top_tips: TopTip[];
}

interface Iprops {
  updateTopTip: (
    id: string,
    likes: number,
    dislikes: number,
    isLikeClick: boolean
  ) => Promise<void>;
  setIsModalOpen: (show: boolean) => void;
  top: Top[];
  pageType?: EPageType;
  setShowErrorModal?: React.Dispatch<React.SetStateAction<boolean>>;
}
type myTopTip = {
  id: string;
  isLiked: boolean;
  isDisliked: boolean;
  likes: number;
  dislikes: number;
};

const TopTips = ({
  top,
  setIsModalOpen,
  updateTopTip,
  pageType,
  setShowErrorModal
}: Iprops) => {
  const [myTopTips, setMyTopTips] = useState<myTopTip[]>([]);
  const { user }: any = useAuthContext();
  const router = useRouter();
  useEffect(() => {
    if (myTopTips.length > 0)
      localStorage.setItem('myTopTips', JSON.stringify(myTopTips));
  }, [myTopTips]);

  const SetTopTipHandler = (storedTopTips: string) => {
    try {
      const parsedTopTips: myTopTip[] = JSON.parse(storedTopTips) as myTopTip[];
      if (myTopTips.length === 0)
        setMyTopTips(
          parsedTopTips.map(ptt => {
            const foundTT = top[0].top_tips?.find(tt => tt.id == ptt.id);
            if (foundTT) {
              return {
                ...ptt,
                likes: foundTT.likes,
                dislikes: foundTT.dislikes
              };
            }
            return {
              ...ptt
            };
          })
        );
    } catch (error) {}
  };
  useEffect(() => {
    if (top[0]?.top_tips?.length > 0) {
      const storedTopTips = localStorage.getItem('myTopTips');
      if (storedTopTips) {
        if (user?.emailVerified && pageType === EPageType.THINGS_TODO) {
          SetTopTipHandler(storedTopTips);
        } else {
          SetTopTipHandler(storedTopTips);
        }
      }
    }
  }, [top[0]]);

  const handleDisLikeClick = (id: string, likes: number, dislikes: number) => {
    const myToolTip = myTopTips.find(tt => tt.id === id);
    if (myToolTip) {
      setMyTopTips(
        myTopTips.map(mtt => {
          if (mtt.id === id) {
            updateTopTip(
              id,
              mtt?.isLiked
                ? mtt.likes === 0
                  ? mtt.likes
                  : mtt.likes - 1
                : mtt.likes,
              mtt.isDisliked
                ? mtt.dislikes === 0
                  ? mtt.dislikes
                  : mtt.dislikes - 1
                : mtt.dislikes + 1,
              false
            );

            return {
              ...mtt,
              isDisliked: mtt.isDisliked ? false : true,
              dislikes: mtt.isDisliked
                ? mtt.dislikes === 0
                  ? mtt.dislikes
                  : mtt.dislikes - 1
                : mtt.dislikes + 1,
              likes: mtt?.isLiked
                ? mtt.likes === 0
                  ? mtt.likes
                  : mtt.likes - 1
                : mtt.likes,
              isLiked: false
            };
          }
          return mtt;
        })
      );
    } else {
      setMyTopTips([
        ...myTopTips,
        {
          id,
          isLiked: false,
          isDisliked: true,
          likes,
          dislikes: dislikes + 1
        }
      ]);
      updateTopTip(id, likes, dislikes + 1, false);
    }
  };
  const handleLikeClick = async (
    id: string,
    likes: number,
    dislikes: number
  ) => {
    const myToolTip = myTopTips.find(tt => tt.id === id);
    if (myToolTip) {
      setMyTopTips(
        myTopTips.map(mtt => {
          if (mtt.id === id) {
            updateTopTip(
              id,
              mtt.isLiked
                ? mtt.likes === 0
                  ? mtt.likes
                  : mtt.likes - 1
                : mtt.likes + 1,
              mtt?.isDisliked
                ? mtt.dislikes === 0
                  ? mtt.dislikes
                  : mtt.dislikes - 1
                : mtt.dislikes,
              true
            );
            return {
              ...mtt,
              isLiked: mtt.isLiked ? false : true,
              likes: mtt.isLiked
                ? mtt.likes === 0
                  ? mtt.likes
                  : mtt.likes - 1
                : mtt.likes + 1,
              dislikes: mtt?.isDisliked
                ? mtt.dislikes === 0
                  ? mtt.dislikes
                  : mtt.dislikes - 1
                : mtt.dislikes,
              isDisliked: false
            };
          }
          return mtt;
        })
      );
    } else {
      setMyTopTips([
        ...myTopTips,
        { id, isLiked: true, isDisliked: false, likes: likes + 1, dislikes }
      ]);
      updateTopTip(id, likes + 1, dislikes, true);
    }
  };

  const handleThingstodoLikeClick = async (
    id: string,
    likes: number,
    dislikes: number
  ) => {
    updateTopTip(id, likes + 1, dislikes, true);
  };

  const handleThingstodoDisLikeClick = async (
    id: string,
    likes: number,
    dislikes: number
  ) => {
    updateTopTip(id, likes, dislikes + 1, false);
  };

  const [showAllTips, setShowAllTips] = useState(false);
  const [visibleTips, setVisibleTips] = useState(6);
  const handleSeeMoreClick = () => {
    setShowAllTips(!showAllTips);
    setVisibleTips(showAllTips ? 6 : top[0]?.top_tips.length);
  };

  useEffect(() => {
    const handleBackButton = () => {
      localStorage.setItem(
        'referringPage',
        `${window.location.origin}${router.asPath}`
      );
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  const openModalHandler = () => {
    if (pageType === EPageType.THINGS_TODO && !user?.emailVerified) {
      localStorage.setItem('referringPage', window.location.href);
      setShowErrorModal && setShowErrorModal(true);
    } else {
      setIsModalOpen(true);
    }
  };
  const DislikeTipHandler = (id: string, likes: number, dislikes: number) => {
    if (pageType === EPageType.THINGS_TODO) {
      if (user?.emailVerified) {
        handleThingstodoDisLikeClick(id, likes, dislikes);
      } else {
        localStorage.setItem('referringPage', window.location.href);
        setShowErrorModal && setShowErrorModal(true);
      }
    } else {
      handleDisLikeClick(id, likes, dislikes);
    }
  };
  const LikeTipHandler = (id: string, likes: number, dislikes: number) => {
    if (pageType === EPageType.THINGS_TODO) {
      if (user?.emailVerified) {
        handleThingstodoLikeClick(id, likes, dislikes);
      } else {
        localStorage.setItem('referringPage', window.location.href);
        setShowErrorModal && setShowErrorModal(true);
      }
    } else {
      handleLikeClick(id, likes, dislikes);
    }
  };

  return (
    <div className="flex-col w-full flex-wrap font-bold gap-4 ">
      <div
        className={`${
          pageType == EPageType.THINGS_TODO ? 'static' : 'sticky'
        } top-20 flex xxsm:justify-between msm:justify-normal xxsm:gap-0 msm:gap-8 mt-8 mb-3 font-semibold `}
      >
        <h2
          className={`md:pl-0 ${
            pageType == EPageType.THINGS_TODO
              ? `xxsm:text-[22px] sm:text-[26px] xl:text-[32px]`
              : ` text-[20px] xl:text-[24px]`
          }  font-semibold`}
        >
          Top Tips
        </h2>

        <button
          onClick={event => {
            event.stopPropagation();
            openModalHandler();
          }}
          className="flex items-center justify-center rounded-full border-gray-200 bg-[#1F2C5B] w-8 h-8 text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
          >
            <path
              d="M13.9286 8.57143H8.57143V13.9286C8.57143 14.2127 8.45855 14.4853 8.25761 14.6862C8.05668 14.8871 7.78416 15 7.5 15C7.21584 15 6.94332 14.8871 6.74239 14.6862C6.54145 14.4853 6.42857 14.2127 6.42857 13.9286V8.57143H1.07143C0.787268 8.57143 0.514746 8.45855 0.313814 8.25762C0.112883 8.05668 0 7.78416 0 7.5C0 7.21584 0.112883 6.94332 0.313814 6.74239C0.514746 6.54145 0.787268 6.42857 1.07143 6.42857H6.42857V1.07143C6.42857 0.787268 6.54145 0.514746 6.74239 0.313814C6.94332 0.112882 7.21584 0 7.5 0C7.78416 0 8.05668 0.112882 8.25761 0.313814C8.45855 0.514746 8.57143 0.787268 8.57143 1.07143V6.42857H13.9286C14.2127 6.42857 14.4853 6.54145 14.6862 6.74239C14.8871 6.94332 15 7.21584 15 7.5C15 7.78416 14.8871 8.05668 14.6862 8.25762C14.4853 8.45855 14.2127 8.57143 13.9286 8.57143Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div className="">
        <div className="gap-4 lg:pr-[12px] grid grid-col-1 lg:grid-cols-2">
          {top[0]?.top_tips?.length > 0 ? (
            top[0]?.top_tips?.map((tip, index) => (
              <div
                className={`flex xl:h-[75px] flex-col gap-4 py-[24px] px-[15px] align-center rounded-[12px] bg-[#F8FBFF] shadow-md justify-center ${
                  !showAllTips && index >= visibleTips ? 'hidden' : ''
                }`}
                key={tip.id}
              >
                <div className="flex justify-between gap-1 xsm:gap-4  font-light  ">
                  <span className=" text-[14px] msm:text-[16px]">
                    {tip.text}
                  </span>
                  <div className="flex justify-end gap-3 items-center">
                    <div className="flex gap-1">
                      <button
                        onClick={event => {
                          LikeTipHandler(tip.id, tip.likes, tip.dislikes);
                          event.stopPropagation();
                        }}
                        className="text-green w-[20px] h-[20px]"
                      >
                        {pageType === EPageType.THINGS_TODO ? (
                          tip.liked ? (
                            <Image
                              src="/like_selected.svg"
                              width={20}
                              height={20}
                              alt="like"
                              className="w-[20px] h-[20px]"
                            />
                          ) : (
                            <Image
                              src="/like_unselected.svg"
                              width={20}
                              height={20}
                              alt="like"
                              className="w-[20px] h-[20px]"
                            />
                          )
                        ) : myTopTips.find(mtt => mtt.id === tip.id)
                            ?.isLiked ? (
                          <Image
                            src="/like_selected.svg"
                            width={20}
                            height={20}
                            alt="like"
                            className="w-[20px] h-[20px]"
                          />
                        ) : (
                          <Image
                            src="/like_unselected.svg"
                            width={20}
                            height={20}
                            alt="like"
                            className="w-[20px] h-[20px]"
                          />
                        )}
                      </button>
                      {pageType === EPageType.THINGS_TODO ? (
                        <span>{tip.likes ?? tip.likes}</span>
                      ) : (
                        <span>
                          {myTopTips.find(mtt => mtt.id === tip.id)?.likes ??
                            tip.likes}
                        </span>
                      )}{' '}
                    </div>
                    <div className="flex gap-1">
                      <button
                        className="text-red-300 w-[20px] h-[20px]"
                        onClick={event => {
                          DislikeTipHandler(tip.id, tip.likes, tip.dislikes);
                          event.stopPropagation();
                        }}
                      >
                        {pageType === EPageType.THINGS_TODO ? (
                          tip.disliked ? (
                            <Image
                              src="/dislike_selected.svg"
                              width={20}
                              height={20}
                              alt="dislike"
                              className="w-[20px] h-[20px]"
                            />
                          ) : (
                            <Image
                              src="/dislike_unselected.svg"
                              width={20}
                              height={20}
                              alt="dislike"
                              className="w-[20px] h-[20px]"
                            />
                          )
                        ) : myTopTips.find(mtt => mtt.id === tip.id)
                            ?.isDisliked ? (
                          <Image
                            src="/dislike_selected.svg"
                            width={20}
                            height={20}
                            alt="dislike"
                            className="w-[20px] h-[20px]"
                          />
                        ) : (
                          <Image
                            src="/dislike_unselected.svg"
                            width={20}
                            height={20}
                            alt="dislike"
                            className="w-[20px] h-[20px]"
                          />
                        )}
                      </button>
                      {pageType === EPageType.THINGS_TODO ? (
                        <span>{tip.dislikes ?? tip.dislikes}</span>
                      ) : (
                        <span>
                          {myTopTips.find(mtt => mtt.id === tip.id)?.dislikes ??
                            tip.dislikes}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div id="top-tips" className="mt-5 text-base font-medium">
              <h2>
                Looks like there are no tips. Be the first one to add a tip to
                help people enjoy!{' '}
              </h2>
            </div>
          )}
        </div>
      </div>
      <div
        className={`${
          top[0]?.top_tips?.length < 6 ? 'py-5' : 'py-8 md:py-10'
        } ${
          pageType !== EPageType.THINGS_TODO && 'border-b border-b-[#E6E6E6]'
        }  mr-[12px]`}
      >
        {top[0]?.top_tips?.length > 6 && (
          <button
            onClick={handleSeeMoreClick}
            className="text-base font-semibold float-right"
          >
            {showAllTips ? 'Show Less' : 'See More'}
          </button>
        )}
      </div>
    </div>
  );
};

export default TopTips;
